export const sharedWithValueParser = (sharedValue: string) => {
  if (sharedValue) {
    return sharedValue === 'agents' ? 'Agents' : 'CastingApp Notice Board';
  }
};
